import React, { useState, forwardRef, useImperativeHandle } from "react";
import {Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        CircularProgress
} from "@material-ui/core";
import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';

const JobReopen = forwardRef((props, ref) => {
    const { closeMenu, onReopenSuccess } = props;
    const classes = useStyles();
    const [jobId, setJobId] = useState(-1);
    const [openReopenJobDialog, setOpenReopenJobDialog] = useState(false);
    const [isReopening, setIsReopening] = useState(false);

    useImperativeHandle(ref, () => ({

      openReopenPopup(jobId) {
        console.log(jobId);
        setJobId(jobId);
        handleClickJobCompletionPopup();
      }

    }));


    const handleClickJobCompletionPopup = () => {
      closeMenu();
      setOpenReopenJobDialog(true);
    };

    const handleCloseReopenJob = () => {
      setOpenReopenJobDialog(false);
    };

    const handleReopenJob = async() => {
      setIsReopening(true);
      const response = await ttAPI.reopenJob(jobId);
      setIsReopening(false);

      if (response && response !== null && response.success) {
          sendNotification('success', `Success - Job ${jobId} reopened.`, classes);
          handleCloseReopenJob();
          onReopenSuccess();
      }
      else {
          sendNotification('error', `Error - Job ${jobId} NOT Reopened. ${response && response !== null && response.message && response.message !== null ? response.message : ''}`, classes);
          handleCloseReopenJob();
      }
    };

  return (
    <>
    <Dialog open={openReopenJobDialog} onClose={handleCloseReopenJob} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">Reopen Job</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to reopen job {jobId}
        </DialogContentText>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseReopenJob} className={classes.cancelButton}>
          Cancel
        </Button>
          <Button onClick={handleReopenJob} disabled={isReopening}>
            {isReopening && <span><CircularProgress size={25}/> Reopening...</span>}
            {!isReopening && <span>Reopen</span>}
          </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default JobReopen;
